const CartIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" fill="none" viewBox="0 0 20 22">
  <path fill="#fff" d="M16.625 21.5H3.875C2.045 21.5.5 19.954.5 18.125V8c0-.827.673-1.5 1.5-1.5h3v-.75A5.256 5.256 0 0 1 10.25.5a5.256 5.256 0 0 1 5.25 5.25v.75h3c.827 0 1.5.673 1.5 1.5v10.184c0 .886-.358 1.722-1.009 2.353-.64.62-1.48.963-2.366.963ZM2 8v10.125C2 19.124 2.876 20 3.875 20h12.75c1.016 0 1.875-.832 1.875-1.816V8H2Zm4.5-1.5H14v-.75A3.754 3.754 0 0 0 10.25 2 3.754 3.754 0 0 0 6.5 5.75v.75Z" />
</svg>


export default CartIcon;
